import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios-https-proxy-fix";
import { toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import "./Translations.scss"
import translator from "../../../utils/translator";

export class Translations extends Component {
    state = {
        response: {},
        search_query: "",
        searchTimeout: null,
        section_list: [],
        section: "",
        translations: []
    };

    toast_config = {
        position: "bottom-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
    };

    // ============= AJAX FUNCTIONS =============

    callAjax = async (route, data) => {
        data.trendId = localStorage.getItem("trendId");
        data.token = localStorage.getItem("token");

        let APIResponse = await Axios.post(this.props.APIUrl + route, data);

        if (APIResponse.data.hasOwnProperty("error")) {
            toast.error(APIResponse.data.error, this.toast_config);
            return false;
        }
        return APIResponse.data;
    };

    componentDidMount = async () => {
        let loadingToast = toast.info(translator("Misc", "loading_label"), this.toast_config);

        let response = await this.callAjax("/language/get-sections", {});
        this.setState({ section_list: response.section_list });

        toast.dismiss(loadingToast);
    };

    getTranslations = async section => {
        if (!section) return;

        let loadingToast = toast.info(translator("Misc", "loading_label"), this.toast_config);

        this.setState({ section: section, response: { loadingbar: translator("Misc", "loading_label") } });
        let route = "/language/get-translations";
        let response = await this.callAjax(route, { section: section });

        toast.dismiss(loadingToast);

        if (!response) return;
        if (!response.hasOwnProperty("translations")) this.setState({ translations: [] });
        else this.setState({ translations: response.translations });
    };

    saveTranslation = async (index, language) => {
        let savingToast = toast.info(translator("Misc", "saving_label"), this.toast_config);

        let response = await this.callAjax("/language/save-translation", {
            section: this.state.section,
            key: this.state.translations[index].key,
            language: language,
            value: this.state.translations[index][language]
        });
        toast.dismiss(savingToast);
        if (!!response.success) {
            toast.success(translator("Misc", "update_success"), { ...this.toast_config, autoClose: 2000 });
            let state = this.state;
            state.translations[index].new = 0;
            this.setState(state);
        }
    }

    // ============= HANDLER FUNCTIONS =============

    searchSections = query => {
        window.clearTimeout(this.state.searchTimeout);
        this.setState({
            searchTimeout: window.setTimeout(this.getSections, 500, query)
        });
    };

    setTranslation = (index, language, event) => {
        let state = this.state;
        state.translations[index][language] = event.target.value;
        this.setState(state);
    }

    // ============= RENDER FUNCTIONS =============

    renderSections = state => {
        let section_options = state.section_list.map(section => ({
            value: section.title,
            text: section.title,
            children: (
                <div className="section_dropdown">
                    {section.title}
                    {!!section.new
                        ? (<span className="new-flag">({section.new})</span>)
                        : ""
                    }
                </div>
            )
        }));

        return (
            <div class="card user-profile-card mb1">
                <div class="card-body">
                    <div className="search-wrapper">
                        <Dropdown
                            fluid
                            search
                            selection
                            placeholder={translator("Misc", "section_label")}
                            options={section_options}
                            value={state.section}
                            onChange={(e, data) => this.getTranslations(data.value)}
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderSettings = state => {
        return (
            <div class="card user-profile-card">
                <div class="card-body">

                    <table className="translation-table">
                        {state.translations.map((phrase, i) => (
                            <>
                                <tbody className={!!phrase.new ? "tbody-new" : ""}>
                                    {["en", "fr"].map(lang => (
                                        <tr className="translation-row">
                                            <td className="lang-label">{lang}</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={phrase[lang]}
                                                    onChange={event => this.setTranslation(i, lang, event)}
                                                />
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-primary save-translation"
                                                    onClick={() => this.saveTranslation(i, lang)}
                                                >
                                                    <i class="fas fa-save"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tbody>
                                    <tr><td colSpan="3" className="table-spacer"></td></tr>
                                </tbody>
                            </>
                        ))}
                    </table>
                </div>
            </div>
        );
    };

    renderResponse = response => {
        if (Object.keys(response).length === 0) return null;
        let key = "error";
        if (response.hasOwnProperty("success")) key = "success";
        if (response.hasOwnProperty("loadingbar")) key = "loadingbar";
        let cardClass = "card user-profile-card response-" + key;
        return (
            <div className={cardClass}>
                <div class="card-body">{response[key]}</div>
            </div>
        );
    };

    render() {
        let state = this.state;
        let main = (
            <>
                {this.renderSections(state)}
                {state.section ? this.renderSettings(state) : null}
            </>
        );
        return (
            <SettingsWrapper header={translator("Admin Menu", "translations_title")} main={main} classes="edit-translations" />
        );
    }
}

const mapStateToProps = state => ({
    APIUrl: state.APIUrl,
    selected_language: state.selected_language
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Translations);
